import { Button, Icon, Text } from '@ksyos/design-system';
import { Modal } from '@frontend/components/elements/modals/Modal';
import { translateKey } from '../../../../translate';

interface IServiceOrganizationGroupSettingChangedOrDeletedModalProps {
    isChanged: boolean;
    isDeleted: boolean;
    isSaving: boolean;
    onClose: () => void;
    onSave: () => void;
}

export function ServiceOrganizationGroupSettingChangedOrDeletedModal(
    props: IServiceOrganizationGroupSettingChangedOrDeletedModalProps
) {
    const { onClose, onSave, isSaving, isDeleted, isChanged } = props;
    const text = getText();

    return (
        <Modal
            actionButtons={[
                <Button
                    onClick={() => onClose()}
                    variant="outline"
                >
                    {translateKey('common.cancel')}
                </Button>,
                <Button
                    isDisabled={isSaving}
                    onClick={onSave}
                >
                    {text.button}
                </Button>,
            ]}
            isOpen={true}
            onClose={() => onClose()}
            size="medium"
            title={text.title}
            titleIcon={
                <Icon
                    color="warning"
                    icon="warning"
                    sx={{ flexShrink: 0, marginRight: '8px' }}
                />
            }
        >
            <Text mb={8}>{text.body}</Text>
        </Modal>
    );

    function getText() {
        if (isDeleted && isChanged) {
            return {
                title: 'Zorgroep verwijderen & wijzigen',
                body: 'Deze wijziging heeft mogelijk financiële gevolgen. Neem contact op met Finance.',
                button: 'Bevestig',
            };
        }
        if (isDeleted) {
            return {
                title: 'Zorggroep verwijderen',
                body: 'Deze wijziging heeft mogelijk financiële gevolgen. Neem contact op met Finance.',
                button: 'Verwijder',
            };
        }

        return {
            title: 'Zorggroep wijzigen',
            body: 'Deze wijziging heeft mogelijk financiële gevolgen. Neem contact op met Finance.',
            button: 'Bevestig',
        };
    }
}
